import messageBox from './messageBox.vue'
import { createApp } from 'vue'
import { GxxtButton } from '@/components'
import OpenAppWx from '@/components/open-app-bar/open-app-wx.vue'
import { WxAndMobile } from '@/utils/common'

export const $messageBox = {};

$messageBox.install = function (app, options) {
	// 1. 添加全局方法或 property
	app.config.globalProperties.$messageBox = function ({
		context, //上下文
		title = '提示文字',
		subTitle = '副标题',
		cancelBtnText = '取消',
		btnType = 1,
		cancelBtnClass = '',
		confirmBtnText = '确定',
		confirmBtnClass = '',
		show = true,
		cancelCallback = () => { },
		confirmCallback = () => { },
		extInfo = {},
		showOpenApp = false,
		isMobileWx = WxAndMobile(),
		ratio = app.config.globalProperties.ratio,
		origin = null
	}) {
		let wrapper = document.createElement('div');
		document.body.appendChild(wrapper);
		var MyComponent = createApp({
			...messageBox, data() {
				return {
					context,
					title,
					subTitle,
					btnType,
					cancelBtnText,
					cancelBtnClass,
					confirmBtnText,
					confirmBtnClass,
					show: true,
					cancelCallback,
					confirmCallback,
					extInfo,
					showOpenApp,
					isMobileWx,
					ratio,
					origin
				}
			},
			components: { GxxtButton, OpenAppWx }
		})
		MyComponent.mount(wrapper);
	}
}
